import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, CartUpdateEvent } from '@theme/events';
import { CartProgressBarController } from '@theme/cart-progress-bar';

class CartDrawerComponent extends DialogComponent {
  /** @type {CartProgressBarController | null} */
  #progressBar = null;

  /** @type {(event: Event) => void} */
  #handleCartAdd;

  connectedCallback() {
    super.connectedCallback();
    this.#progressBar = new CartProgressBarController(this, { updateHeading: true });
    this.#progressBar.connect();

    this.#handleCartAdd = (event) => {
      if (this.hasAttribute('auto-open') && event.type === CartAddEvent.eventName) {
        this.showDialog();
      }
    };

    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    if (this.dialog && this.dialog.hasAttribute('open')) {
      this.#progressBar.updateProgressBar();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#progressBar?.disconnect();
    this.#progressBar = null;
  }

  open() {
    this.showDialog();
    this.#progressBar?.reconcileNow();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
